import {SubIcon} from './SubIcon';
import { EditIcon } from './EditIcon';
import React, { Component } from 'react';
import { OpenSiteIcon } from './OpenSiteIcon';
import {WatchIcon} from './WatchIcon';
import {BlueStats} from './BlueStats';
import {TrashIcon} from './TrashIcon';
import {PageNotActiveIcon} from './PageNotActiveIcon';

import {ActiveIcon} from './ActiveIcon';
import VkLogo from './vk_logo.png';
import TgLogo from './TgLogo.png';


export class WidgetBlock extends React.Component {

    constructor(props) {
        super(props);
        if (this.props.cnt_sub == null) {
            this.cnt_sub = 0
        }
        else {
            this.cnt_sub = this.props.cnt_sub
        }

        if (this.props.total_views == null) {
            this.total_views = 0
        }
        else {
            this.total_views = this.props.total_views
        }   

        if (this.total_views == 0) {
            this.conversion = 0
        }
        else {
            this.conversion = this.cnt_sub / this.total_views
            
            this.conversion = Math.floor(this.conversion * 100) 
        }
        
    }

    render() {
        return (
            <div className='pages_pagesBlock_pageBlock'>
                                        <div className='pages_pagesBlock_pageBlock_logo' >
                                            {this.props.social == 'vk' ? <img src={VkLogo} /> : null }
                                            {this.props.social == 'tg' ? <img src={TgLogo} /> : null }
                                        
                                        </div>
                                        <div className='pages_pagesBlock_pageBlock_name'>
                                           {this.props.widget_name}
                                        </div>
                                        <div className='pages_pagesBlock_pageBlock_bgImg_block'>
                                            <div style={{backgroundImage: `url(${this.props.big_img_src})`}} 
                                            className='pages_pagesBlock_pageBlock_bgImg'></div>
                                        </div>
        
                                        <div className='pages_pagesBlock_pageBlock_btn_row1'>
                                                <a href={'/redwidget/'+this.props.social+'/'+this.props.alias}><EditIcon /> Редактировать</a>
                                                <a 
                                                href={this.props.social == 'tg' ?  
                                                '/widgetimplementation/' +  this.props.alias
                                                :
                                                '/vkwidgetimplementation/' +  this.props.alias}>
                                                    <OpenSiteIcon /> Установка на сайт</a>
                                        </div>
        
                                      {/*<div className='pages_pagesBlock_pageBlock_btn_row2'>
                                            <a href='#'>  <OpenSiteIcon /> Открыть сайт</a>   
                                        </div>*/}
        
                                      <div className='pages_pagesBlock_pageBlock_statsBlock'>
                                          <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'><SubIcon/></div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row2'>Подписки</div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>{this.cnt_sub}</div>
                                          </div>
                                          <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'><WatchIcon /></div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row2'>Просмотры</div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>{this.total_views}</div>
                                          </div>
                                          <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1 statsBlock_blueStatsIcon'><BlueStats/></div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row2'> Конверсия </div>
                                              <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'> {this.conversion}% </div>
                                          </div>
                                      </div>
        
                                      <div className='pages_pagesBlock_pageBlock_bottom'>
                                          <div className='pages_pagesBlock_pageBlock_bottom_deleteBlock'
                                           onClick={ () => {
                                            if(window.confirm(this.props.confirmMsg)) {
                                                this.props.delete(this.props.alias, this.props.social)
                                            }
                                            
                                          }}>
                                            <TrashIcon />   Удалить
                                          </div>
        
                                          <div className='pages_pagesBlock_pageBlock_bottom_activeBlock'>
                                            
                                            { !this.props.is_active ? 
                                            <div>Не активно <PageNotActiveIcon /></div>
                                            :
                                            <div>Активно <ActiveIcon /></div> }
                                          </div>
        
                                      </div>
        
                                    </div> 
        )
    }
}

